import '../css/button.css'

const Button = ({ handleClick, className, children, style }) => {
    return (
        <button
            onClick={handleClick}
            style={{...style}}
            className={className}
        >{children}</button>
    );
}

export default Button;